var lib_core      = require("lib-core");
var THREE         = require("three");

var LocalRotationModel  = require("./../abstract/localRotationHandleModel.js");

var LocalYRotationModel = function (editorModel, handleId, config) {
    LocalRotationModel.call(this, editorModel, handleId, config);
};

lib_core.inherit(LocalYRotationModel, LocalRotationModel);
LocalYRotationModel.$class = "LocalYRotationModel";
module.exports = LocalYRotationModel;

LocalYRotationModel.prototype.getSubjectsRotation = function(){
    return this.getSubject().getRotation();
} 

LocalYRotationModel.prototype.released = function(){
    this.selected(false);
}

LocalYRotationModel.prototype.setContactPosition = function(position){
    this.selected(true);
    var subject = this.getSubject();
    this.startRotation = subject.getRotation().y;
    var basePos = subject.getPosition();
    var vectorToCenter = position.sub(basePos);

    var xaxis = new THREE.Vector3( 1, 0, 0 );
    var xrotate = -subject.getRotation().x * Math.PI/180;
    vectorToCenter.applyAxisAngle( xaxis, xrotate );

    vectorToCenter.normalize();
    var angle = Math.atan2(vectorToCenter.x, vectorToCenter.z);
    this.startAngle = angle;
}


LocalYRotationModel.prototype.createMovementPlane = function(ray, point){
    var subject = this.getSubject();
    var newRay = new THREE.Vector3(0,1,0);

    var xaxis = new THREE.Vector3( 1, 0, 0 );
    var xrotate = subject.getRotation().x * Math.PI/180;
    newRay.applyAxisAngle( xaxis, xrotate );

    var zero = new THREE.Vector3();
    var pos = subject.getPosition();
    var vecToOrigin = new THREE.Vector3( pos.x, pos.y, pos.z );
    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

LocalYRotationModel.prototype.setMousePosition = function(position){

    var subject = this.getSubject();
    var basePos = subject.getPosition();
    var vectorToCenter = position.sub(basePos);

    var vecLength = vectorToCenter.length();

    var xaxis = new THREE.Vector3( 1, 0, 0 );
    var xrotate = -subject.getRotation().x * Math.PI/180;
    vectorToCenter.applyAxisAngle( xaxis, xrotate );

    vectorToCenter.normalize();
    var newAngle = Math.atan2(vectorToCenter.x, vectorToCenter.z);

    var absangle = (newAngle - this.startAngle) + ((this.startRotation)*(Math.PI/180));
    var snapcount = Math.round((absangle)/(Math.PI/2));
    var snapnum = snapcount * Math.PI/2;

    if(this.snapped()){
        if(Math.abs(absangle - snapnum) < 0.1){
            subject.inspectorRotationY(snapnum* (180/Math.PI));
        } else {
            var angleDiff = newAngle - this.startAngle;
            subject.inspectorRotationY( this.startRotation + parseFloat((angleDiff) * 180 / Math.PI));
            this.snapped(false);
        }
    } else {
        if(Math.abs(absangle - snapnum) < 0.01){
            subject.inspectorRotationY(snapnum* (180/Math.PI));
            this.snapped(true);
        } else {
            var angleDiff = newAngle - this.startAngle;
            subject.inspectorRotationY( this.startRotation + parseFloat((angleDiff) * 180 / Math.PI));
        }
    }
}


